import type { PortalInvoice } from "../types/portal.types.ts"

export const isOutstanding = (invoice: PortalInvoice) =>
  Number(invoice.amount) - Number(invoice.paid_to_date || 0) > 0
